import Vue from 'vue';

// import the toast
import Toast from "@/components/widgets/toast.vue";

const ToastComponent = Vue.extend(Toast);

const ToastPlugin = {
  install(Vue) {
    const instance = new ToastComponent();
    instance.$mount();
    // we should append the html element to document body
    document.body.appendChild(instance.$el);
    Vue.prototype.$toast = instance;
  }
};

export default ToastPlugin;
